const rootElement = document.querySelector('#hb-lp-info-popup')
const toggleBtn = rootElement.querySelector('.js-toggle-icons');
const toggleBlock = rootElement.querySelector('.js-toggle-block');
const manualSection = document.querySelector('[data-user-manual-title]');
const popupTopic = document.getElementById('js-popup-topic');

if (toggleBtn && toggleBlock) {
  const dots = toggleBtn.querySelector('.js-icon-dots');
  const close = toggleBtn.querySelector('.js-icon-close');

  toggleBtn.addEventListener('click', function () {
    toggleBlock.classList.toggle('tw:-bottom-160');
    toggleBlock.classList.toggle('tw:bottom-20');
    toggleBlock.classList.toggle('tw:opacity-0');

    if (dots && close) {
      dots.classList.toggle('tw:hidden');
      close.classList.toggle('tw:hidden');
    }
});
}

if (manualSection && popupTopic) {
  const manualTitle = manualSection.dataset.userManualTitle;

  if (manualTitle) {
    popupTopic.textContent = manualTitle;
  }
}
